<template>
  <unicom-linha :espacamento="false" class="cartao-endereco noselect">
    <unicom-coluna sm="auto" md="auto">
      <div class="medio negrito">{{ objetoEndereco.tipo }}</div>
      <div class="my-2">{{ objetoEndereco.documento }}</div>
      <div class="segunda-cor-fonte">{{ objetoEndereco.endereco }}</div>
    </unicom-coluna>
    <unicom-coluna sm="auto" md="auto" alinhamento="end" class="ml-auto">
      <div class="codigo">Código: {{ objetoEndereco.codigo }}</div>
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
export default {
  props: {
    objetoEndereco: {
      type: Object,
      default: () => {
        return {
          tipo: "",
          documento: "",
          endereco: "",
          codigo: ""
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cartao-endereco {
  cursor: pointer;
  padding: 16px;
  border-radius: 8px;
  background: #f2f5f400;
  border: 1px solid #dee2e6;
  box-shadow: 0px 3px 5px #00000000;
  transition: all 0.15s ease;

  .codigo {
    text-align: center;
    padding: 8px 12px;
    width: 68px;
    background: #00995d1a;
    border-radius: 8px;
    color: #00995d;
  }

  &:hover {
    box-shadow: 0px 2px 4px #60656c2e;
    background: #fdfdfd 0% 0% no-repeat padding-box;
  }
}
</style>
